import React from 'react';
import _get from 'lodash/get';
import { useQuery } from 'react-query';
import { fetchListenNotesData } from 'components/AudioCard';

export const PodcastSmallCard = ({ Component, ...rest }) => {
  const { item } = rest;
  const { data } = useQuery(
    [
      'listenotes',
      {
        finalType: _get(item, 'fields.type'),
        listenNotesId: _get(item, 'fields.listenNotesId'),
      },
    ],
    fetchListenNotesData,
  );

  const episode = _get(data, 'data.episodes')
    ? data.data.episodes[0]
    : _get(data, 'data');
  const audioLength = _get(episode, 'audio_length_sec', 0);
  const minutes = audioLength && Math.round(((audioLength / 60) * 100) / 100);

  return <Component {...rest} minutes={minutes} />;
};
